
import Vuex, { GetterTree, MutationTree } from 'vuex';
import {namespace} from 'vuex-class';
import * as Data from './../data';
// tslint:disable


import {PaymentStoreInit} from './../../src/section/affiliateapp/store/payment/PaymentStoreGettersCode';
import {PaymentStoreGettersCode} from './../../src/section/affiliateapp/store/payment/PaymentStoreGettersCode';
import {PaymentStoreMutationsCode} from './../../src/section/affiliateapp/store/payment/PaymentStoreMutationsCode';
import {PaymentStoreGetters} from './payment-store-support';
import {PaymentStoreMutations} from './payment-store-support';


import store from './../store';


const paymentStoreGetters: PaymentStoreGetters = new PaymentStoreGettersCode();
const PaymentStoreGetterTree: GetterTree<Data.Payment.PaymentStore, any> = {
  paymentPlanDetails : (state: Data.Payment.PaymentStore) => paymentStoreGetters.paymentPlanDetails(state),
planDetails : (state: Data.Payment.PaymentStore) => paymentStoreGetters.planDetails(state),
msfSlabList : (state: Data.Payment.PaymentStore) => paymentStoreGetters.msfSlabList(state)
};

const paymentStoreMutations: PaymentStoreMutations = new PaymentStoreMutationsCode();
const PaymentStoreMutationTree: MutationTree<Data.Payment.PaymentStore> = {
  updatePaymentPlanDetails : (state: Data.Payment.PaymentStore, paymentPlanDetails: Data.Payment.PaymentPlanDetails ) => paymentStoreMutations.updatePaymentPlanDetails(state , paymentPlanDetails  ) 
};

const storePaymentStore = {
  namespaced: true,
  state: PaymentStoreInit.initState(),
  mutations : PaymentStoreMutationTree,
  getters: PaymentStoreGetterTree
};

const PaymentStoreSpace = namespace('Payment/PaymentStore');
const PaymentStoreGetter = {
    paymentPlanDetails : PaymentStoreSpace.Getter('paymentPlanDetails') ,
planDetails : PaymentStoreSpace.Getter('planDetails') ,
msfSlabList : PaymentStoreSpace.Getter('msfSlabList') 
};

class PaymentStoreMutationAPI {

  public static UPDATE_PAYMENT_PLAN_DETAILS(paymentPlanDetails: Data.Payment.PaymentPlanDetails ): void {
    store.commit('Payment/PaymentStore/updatePaymentPlanDetails' , paymentPlanDetails );
  }

}




export const PaymentStoreInfo = {
     namespaced: true,
     modules: {
      PaymentStore: storePaymentStore
    }
};


export const PaymentGetter = {
PaymentStore : PaymentStoreGetter
};

export const PaymentMutation = {
PaymentStore : PaymentStoreMutationAPI
};

